
import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Cotizacion } from './cotizacion.model';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';

@Injectable()
export class CotizacionResolver implements Resolve<Cotizacion> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id;
      
      return await this.backendService.get(Cotizacion, Cotizacion.path + id).toPromise();
    } catch (error) {
      this.snackService.error('No puede modificar cotizaciones eliminadas');
      this.router.navigate(['/cotizacion']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/cotizacion/cotizacion.resolver.ts